import React from 'react';
import moment from 'moment';
import { useRecoilValue, useRecoilState } from 'recoil';
import { ratePlanChoice,
  totalPayNowState
 } from 'states/CheckOutStates/atoms';
import { dateRangeState } from 'states/SearchBarStates/atoms';
import { RESERVATION, ADVANCED } from 'constants/ratePlanId';
import { PlanSectionContainer, SectionContainerItem } from './style';
import { isToday } from 'functions/dates';
import { CustomizedRadio } from 'components/CustomizedRadio';

const PlanSection: React.FC<{position?: string}> = ({position}) => {


  const totalPayNow = useRecoilValue(totalPayNowState);
  
  const [ratePlanId, setRatePlanId] = useRecoilState(ratePlanChoice)
  const dateRange = useRecoilValue(dateRangeState);

  const cancelReserveDate = moment(dateRange[0]).format("MM/DD/YY h:mm A")

  const handleSelection = (selectedRatePlanId: string) => {
    setRatePlanId(selectedRatePlanId)
    localStorage.setItem("ratePlanId", selectedRatePlanId)
  }

  const showRatePlanSelector = !isToday(dateRange[0]);

  if (isToday(dateRange[0])) {
    setRatePlanId(RESERVATION)
    localStorage.setItem("ratePlanId", RESERVATION)
  }
  
  return showRatePlanSelector ? (
    <PlanSectionContainer>

      <div className="ratePlanTitle">
        Choose a rate plan:
      </div>
      <div className="selectionContainer">
        <SectionContainerItem
          selected={ratePlanId === ADVANCED}
          onClick={() => handleSelection(ADVANCED)}
        >
          <div className="inputContainer">
            {/* <div className="customizedRadio"></div> */}
            <CustomizedRadio
              checked={ratePlanId === ADVANCED}
              className = "planRadio"
            />
            <div className="title">
              Advanced Purchase (10% off)
            </div>
          </div>
          <div className="choosePlanText">
            Pay an advanced deposit
            <span className="priceInText">&nbsp;
              ${totalPayNow.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}&nbsp;</span> 
            for this booking and receive a <b>10%</b> discount off the total. The remainder of your booking is paid at check in. Cancelled bookings are not refundable. 
            {/* Prepay for your room and receive a 10% discount. Cancel anytime up to 48 hours before your stay ({cancelPrepayDate}). */}
          </div>
        </SectionContainerItem>
        <SectionContainerItem
          selected={ratePlanId === RESERVATION}
          onClick={() => handleSelection(RESERVATION)}
        >
          <div className="inputContainer">
            {/* <div className="customizedRadio"></div> */}
            <CustomizedRadio
              checked={ratePlanId === RESERVATION}
              className = "planRadio"
            />
            <div className="title">
              Pay at Check-in
            </div>
          </div>
          <div className="choosePlanText">
            Stay flexible— reserve now and cancel for free anytime before {cancelReserveDate}. <b>Your credit card will not be charged until you check in</b>.
          </div>
        </SectionContainerItem>
      </div>
    </PlanSectionContainer>
  ) : null;

}

export default PlanSection;
